export default __webpack_public_path__ + "07868fea6b859686fab8af45cdd1f164.png";